$(function () {
    $('.slider-images').slick({
        prevArrow: '<a href="#" class="trigger-previous"></a>',
        nextArrow: '<a href="#" class="trigger-next"></a>',
        asNavFor: '.slider-navigation',
        accessibility: true,
        dots: false
    });

    $('.slider-navigation').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-images',
        arrows: false,
        centerMode: true,
        centerPadding: '0px',
        focusOnSelect: true,
        variableWidth: false,
    });

    $('.slider-images-contact').on('init', function (event, slick) {
        var $slides = slick.$slides;
        var height = 0;

        $slides.each(function () {
            if ($(this).height() > height) {
                height = $(this).height();
            }
        });

        $('.slick-slide', slick.$slideTrack).height(height);
    }).slick({
        prevArrow: '<a href="#" class="trigger-previous"></a>',
        nextArrow: '<a href="#" class="trigger-next"></a>',
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        accessibility: true,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false
            }
        }]
    });
});
